import { render, staticRenderFns } from "./PrizeDescription.vue?vue&type=template&id=a47835c4&"
import script from "./PrizeDescription.vue?vue&type=script&lang=js&"
export * from "./PrizeDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a47835c4')) {
      api.createRecord('a47835c4', component.options)
    } else {
      api.reload('a47835c4', component.options)
    }
    module.hot.accept("./PrizeDescription.vue?vue&type=template&id=a47835c4&", function () {
      api.rerender('a47835c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/lot/components/PrizeDescription.vue"
export default component.exports